<div
  class="header-skeleton loading"
  *ngIf="isLoading; else header"
  [ngStyle]="skeletonStyles"
></div>

<ng-template #header>
  <slot></slot>
</ng-template>
